export enum GregorioSpace {
  DEFAULT,
  NO_SPACE,
  ZERO_WIDTH,
  HALF_SPACE,
  INTERGLYPH_SPACE,
  NEUMATIC_CUT,
  LARGER_SPACE,
  GLYPH_SPACE,
  AD_HOC_SPACE,
  NEUMATIC_CUT_NB,
  LARGER_SPACE_NB,
  GLYPH_SPACE_NB,
  AD_HOC_SPACE_NB,

  INTERELEMENT_SPACE,
}
